<template>
  <div class="app-main-content runningQuery">
    <div class="main-content">
      <div>
        <!-- <el-button type="primary" @click="query">查询</el-button> -->
        <!-- <el-button @click="reset">重置</el-button> -->
      </div>
      <!-- <div class="section" style="background-color:#fff;margin-top:6px;">
        <el-form :inline="true" :model="form" label-width="80px">
          <el-form-item label="机器人名称">
            <el-input v-model="form.robotName" placeholder="请输入机器人名称" style="width:300px;" />
          </el-form-item>
          <el-form-item label="创建时间">
            <el-date-picker v-model="form.startTime" type="date" placeholder="开始时间" />
            <span style="margin:0 10px;">-</span>
            <el-date-picker v-model="form.endTime" type="date" placeholder="截止时间" />
          </el-form-item>
        </el-form>
      </div> -->
      <div class="section" style="background-color:#fff;margin-top:6px;">
        <el-table :data="tableData" border>
          <el-table-column label="序号" prop="sorting" width="50" />
          <el-table-column label="机器人名称" prop="taskName" />
          <el-table-column label="计划名称" prop="taskScheduleName" />
          <el-table-column label="计划属性" prop="robotAttribute" />
          <el-table-column label="运行状态">
            <template slot-scope="scope">
              <span :class="{'setColorOrange':scope.row.runningStatus === 1, 'setColorBlue':scope.row.runningStatus === 3,'setColorGray':scope.row.runningStatus === 2,'setColorRed':scope.row.runningStatus === 4}">{{ runningStatus(scope.row.runningStatus) }}</span>
            </template>
          </el-table-column>
          <el-table-column label="创建时间" prop="dateCreated" />
          <el-table-column label="开始运行时间" prop="startDateTime" />
          <el-table-column label="结束时间" prop="endDateTime" />
          <el-table-column label="运行结果">
            <template slot-scope="scope">
              <span v-show="scope.row.result === 0">/</span>
              <a v-show="scope.row.result === 1" style="color:#1F75D5;text-decoration:underline;" @click="download(scope.row)">下载</a>
              <span v-show="scope.row.result === 2 || scope.row.result === 3" style="color:red;">失败</span>
              <span v-show="scope.row.result === 4">排队中</span>
            </template>
          </el-table-column>

          <el-table-column fixed="right" label="操作" width="300">
            <template slot-scope="scope">
              <el-button type="text" size="small" @click="toView(scope.row)">查看日志</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <el-dialog
      v-el-drag-dialog
      :visible.sync="toViewShow"
      title="查看日志"
      width="580px"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      :show-close="false"
    >
      <div class="dialog-content">
        <span class="detailed-information">详细信息</span>
        <div class="mr-top">
          <span>机器人名称：</span>
          <span class="setColorGray">{{ logForm.taskName }}</span>
        </div>
        <div class="information mr-top">
          <div>
            <span>运行结果：</span>
            <span class="setColorBlue" :class="{'setColorRed':logForm.result === 2 || logForm.result === 3}">{{ resultData(logForm.result) }}</span>
          </div>
          <div>
            <span>运行方式：</span>
            <span class="setColorGray">{{ logForm.taskRunningPlan === 9?'立即运行':logForm.taskRunningPlan === 1?'计划运行':'' }}</span>
          </div>
          <div>
            <span>运行时长：</span>
            <span class="setColorGray">{{ conversionTime(logForm.duration) }}</span>
          </div>
        </div>
        <div class="mr-top">
          <span>开始时间：</span>
          <span class="setColorGray">{{ logForm.startDateTime }}</span>
        </div>
        <span class="detailed-information mr-top">运行日志</span>
        <div class="log-contents mr-top">{{ logForm.traceLog }}</div>
      </div>
      <div slot="footer" style="padding-right:5px;">
        <el-button type="primary" @click="confirm">确认</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { getList } from '@/api/robot/runningQuery'
import { getLoading } from '@/utils/utilBaseElement'
export default {
  data() {
    return {
      toViewShow: false,
      tableData: [],
      loading: false,
      runningTime: '',
      form: {
        robotName: '',
        startTime: '',
        endTime: ''
      },
      logForm: {}
    }
  },
  computed: {
    sessionId() {
      return this.$store.getters.token
    }
  },
  created() {
    this.getListFunc()
  },
  methods: {
    // 查看日志
    async toView(row) {
      this.logForm = row
      this.toViewShow = true
    },
    download(row) {
      if (row.resultFile) {
        window.location.href = row.resultFile
      } else {
        window.location.href = `${window.location.origin}/api/external-service/task/trace/excelResult?sessionId=${this.sessionId}&taskScheduleTraceUuid=${row.taskScheduleTraceUuid}`
      }
    },
    // 转换时间戳
    conversionTime(runningTime) {
      const days = Math.floor(runningTime / (24 * 3600 * 1000)) // 计算出天数
      const leavel1 = runningTime % (24 * 3600 * 1000) // 计算天数后剩余的时间
      const hours = Math.floor(leavel1 / (3600 * 1000)) // 计算天数后剩余的小时数
      const leavel2 = runningTime % (3600 * 1000) // 计算剩余小时后剩余的毫秒数
      const minutes = Math.floor(leavel2 / (60 * 1000)) // 计算剩余的分钟数
      return days + '天' + hours + '小时' + minutes + '分钟'
    },
    // 查询
    async getListFunc() {
      this.loading = getLoading()
      const res = await getList().finally(() => {
        this.loading.close()
      })
      if (res.ok) {
        if (res.data.length !== 0) {
          res.data.forEach((item, index) => {
            item.sorting = index + 1
            item.robotAttribute = '免费'
          })
        }
        this.tableData = res.data
      } else {
        this.tableData = []
      }
    },
    // 日志弹窗确认
    confirm() {
      this.toViewShow = false
    },
    // 转换机器人状态值
    runningStatus(runningStatus) {
      switch (runningStatus) {
        case 0:
          return '待运行'
        case 1:
          return '运行中'
        case 2:
          return '手动终止'
        case 3:
          return '运行完成'
        case 4:
          return '运行失败'
      }
    },
    resultData(result) {
      switch (result) {
        case 1:
          return '成功'
        case 2:
        case 3:
          return '失败'
        case 4:
          return '排队中'
      }
    }
  }
}
</script>
<style lang="scss">
.runningQuery{
  .setColorOrange{
    color:orange;
  }
  .setColorBlue{
    color:#1F75D5;
  }
  .setColorGray{
    color:#999999;
  }
  .setColorRed{
    color:red;
  }
  .banClick{
    opacity: 0.5;
  }
  .el-dialog__title{
    padding-left: 5px;
    color: #333333;
    font-size: 16px;
    font-weight: 600;
  }
  .dialog-content{
    color: #333;
    padding: 0 5px;
    box-sizing: border-box;
    .detailed-information{
      width: 100%;
      height: 36px;
      border-radius: 4px;
      background: linear-gradient(135deg,#e9f3fe, #fdfeff);
      color: #333333;
      font-size: 14px;
      line-height: 36px;
      display: inline-block;
      padding-left: 10px;
      font-weight: 500;
    }
    .mr-top{
      margin-top: 20px;
    }
    .information{
      display: flex;
      justify-content: space-between;
    }
    .log-contents{
      height: 240px;
      border-radius: 4px;
      background: #f7f7f7;
      padding: 10px;
      box-sizing: border-box;
    }
  }
}

</style>
